module.exports = __webpack_public_path__ + "media/src/images/proctored_icons/no_leaving_camera-f5a6bd3efafd045b9e0912393ee60cb8.svg";